import { gql } from '@apollo/client';

const UPDATE_PROJECT_LANGUAGES = gql`
        mutation UpdateProjectLanguages(
            $profileId: Int!
            $projectId: Int!
            $languageId1: Int
            $languageId2: Int
        ) {
            updateProjectLanguages(
                profileId: $profileId
                projectId: $projectId
                languageId1: $languageId1
                languageId2: $languageId2
            )
        }
    `;

export default UPDATE_PROJECT_LANGUAGES;
